import React from 'react';

const LobbyIconV2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.9134 15.6715C14.8771 16.7077 13.2095 16.7077 9.87398 16.7077C6.53854 16.7077 4.87082 16.7077 3.83463 15.6715C2.79845 14.6354 2.79845 12.9676 2.79845 9.63221C2.79845 6.29674 2.79845 4.62902 3.83463 3.59283C4.87082 2.55664 6.53854 2.55664 9.87398 2.55664C13.2094 2.55664 14.8771 2.55664 15.9134 3.59283C16.9495 4.62902 16.9495 6.29674 16.9495 9.63221C16.9495 12.9676 16.9495 14.6354 15.9134 15.6715Z",
      stroke: "#E2E4EE",
      strokeWidth: "1.11719",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M7.63965 16.7077V2.55664", stroke: "#E2E4EE", strokeWidth: "1.11719" }),
  /* @__PURE__ */ React.createElement("path", { d: "M16.9495 6.6543H2.79845", stroke: "#E2E4EE", strokeWidth: "1.11719" }),
  /* @__PURE__ */ React.createElement("path", { d: "M16.9495 12.6113H2.79845", stroke: "#E2E4EE", strokeWidth: "1.11719" })
);
LobbyIconV2.displayName = "Icons.LobbyIconV2";

export { LobbyIconV2 };
//# sourceMappingURL=LobbyIconV2.js.map
